module.exports = __webpack_public_path__ + "img/step3-c.ae1a3822.png";